import { Booking, Flight } from '@/api';
import router from '@/router';
import moment from 'moment';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  name: 'BookingModule',
  namespaced: true,
})
export default class BookingModule extends VuexModule {
  currentStep: number = 1;
  completedStep: number = 0;

  startDate: string | null = moment().format('YYYY-MM-DD');
  endDate: string | null = null;
  parkingPrice: string = '';
  extrasPrice: number | null = null;
  booking: Booking | null = null;
  flightNumberOut: Flight | null = null;
  flightNumberOutText: string = '';
  flightNumberIn: Flight | null = null;
  flightNumberInText: string = '';
  departureTime: string = '';
  depatureConfirm: boolean = false;
  returnTime: string = '';
  titles: string[] = [
    'Mr',
    'Mrs',
    'Miss',
    'Ms',
    'Capt',
    'Dr',
    'Prof',
    'Rev',
    'Sir',
    'Sister',
    'Mr & Mrs',
    'Mrs & Mr',
    'Mrs & Mrs',
    'Ms & Mr',
  ];
  colours: string[] = [
    'White',
    'Black',
    'Grey',
    'Silver',
    'Red',
    'Blue',
    'Brown',
    'Green',
    'Beige',
    'Orange',
    'Gold',
    'Yellow',
    'Purple',
  ];
  makes: string[] = [
    '8 Tonne Truck',
    'Alfa',
    'Allridey',
    'Amarok',
    'American',
    'APV Mahual',
    'Astra',
    'Audi',
    'Aventus',
    'Bentley',
    'BMW',
    'Boat',
    'Bucket Truck',
    'Cadillac',
    'Camper Van',
    'Caravan',
    'Chery',
    'Chevrolet',
    'Chrysler',
    'Citroen',
    'Corolla',
    'Custom',
    'CX8',
    'Daewoo',
    'Daihatsu',
    'Datsun',
    'Delicia',
    'DMAX',
    'Dodge',
    'Ducati',
    'Estima',
    'Fiat',
    'Ford',
    'GMC',
    'Golf',
    'Great Wall',
    'Harley Davison',
    'Hino',
    'Holden',
    'Honda',
    'Hummer',
    'Husqvarna',
    'Hyundai',
    'Isuzu',
    'Iveco',
    'Jaguar',
    'Jeep',
    'JMC',
    'Jumbuck',
    'Kawasaki',
    'Kia',
    'Kluger',
    'Land Cruiser',
    'Land Rover',
    'LDV',
    'Lexus',
    'Lotus',
    'LVD',
    'Mahindra',
    'Maserati',
    'Mazda',
    'Mercedes',
    'MG',
    'Mini',
    'Mitsubishi',
    'Motor Bike',
    'Motor Home',
    'Mustang',
    'Mystery',
    'Nissan',
    'Opel',
    'Pajero',
    'Peugeot',
    'Piaggro',
    'Pontiac',
    'Porsche',
    'Proton',
    'Ram',
    'Range Rover',
    'Ranger',
    'Redsym',
    'Renault',
    'Saab',
    'Skoda',
    'Smart',
    'SsangYong',
    'Subaru',
    'SUV',
    'Suzuki',
    'Tesla',
    'Tiguan',
    'Toyota',
    'Trailer',
    'Truck',
    'Valiant',
    'Van',
    'Volkswagen',
    'Volvo',
    'Western',
    'Wicked',
    'Winnebago',
    'Yamaha',
  ];

  @Mutation
  setCurrentStep(step: number) {
    this.currentStep = step;
  }

  @Mutation
  setCompletedStep(step: number) {
    if (this.completedStep < step) {
      this.completedStep = step;
    }
  }

  @Mutation
  resetCompletedStep() {
    this.completedStep = 0;
  }

  @Mutation
  setStartDate(date: string | null) {
    this.startDate = date;
  }

  @Mutation
  setEndDate(date: string | null) {
    this.endDate = date;
  }

  @Mutation
  setParkingPrice(price: string) {
    this.parkingPrice = price;
  }

  @Mutation
  setExtrasPrice(price: number | null) {
    this.extrasPrice = price;
  }

  @Mutation
  newBooking() {
    this.completedStep = 0;
    this.booking = new Booking({
      bookingType: 'Regular',
      status: 'complete',
      paymentStatus: 'paid',
    });
  }

  @Mutation
  setFlightNumberOut(flight: Flight | null) {
    this.flightNumberOut = flight;
  }

  @Mutation
  setFlightNumberOutText(flight: string) {
    this.flightNumberOutText = flight;
  }

  @Mutation
  setFlightNumberInText(flight: string) {
    this.flightNumberInText = flight;
  }

  @Mutation
  setFlightNumberIn(flight: Flight | null) {
    this.flightNumberIn = flight;
  }

  @Mutation
  setDepartureTime(time: string) {
    this.departureTime = time;
  }

  @Mutation
  setReturnTime(time: string) {
    this.returnTime = time;
  }

  @Mutation
  setDepatureConfirm(confirm: boolean) {
    this.depatureConfirm = confirm;
  }

  @Action
  checkStatus() {
    if (this.completedStep >= 6 && this.currentStep <= this.completedStep) {
      router.push({
        name: 'booking-step-1',
      });
      this.resetCompletedStep();
      this.newBooking();
    } else if (this.currentStep - 1 > this.completedStep) {
      router.push({
        name: 'booking-step-1',
      });
    }
  }
}
